import classes from './HeaderCell.module.css'

export default function HeaderCellGroup({item}) {
    return <div className={classes.cell_top_header}>
        <div className={classes.header_cell_group} style={{backgroundColor: item.bgColor}}>{item.groupName}</div>
    </div>
}